import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class UserTypeService {

  base_URL = BASE_URL;

  constructor(public http: HttpClient) { }

  addUserType(data: any) {
    return this.http.post(this.base_URL + 'userType', data)
  }

  updateUserType(data: any) {
    return this.http.put(this.base_URL + 'userType/update', data)
  }

  getUserTypeById(userTypeId: any, cid: any) {
    return this.http.get(this.base_URL + 'userType/' + userTypeId + '/' + cid)
  }

  getAllUserTypes(cid: any) {
    return this.http.get(this.base_URL + 'userType/all/' + cid)
  }

  deleteUserType(id: any) {
    return this.http.delete(this.base_URL + 'userType/softDelete/' + id)
  }
}
